import AvatarComp from "themes/elements/Avatar";
import ModalComp from "themes/elements/Modal";
import TagComp from "themes/elements/Tag";
import ModalFooter from "../modalFooter";
import "./details.scss";

import { CalenderTermIcon } from "themes/Icon";
function CouncillorDetails({
  setDetails = () => {},
  isDetails,
  data,
  tabActive,
}) {
  return (
    <ModalComp
      title="Councillor change request"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setDetails(false)}
          primaryBtnVariant="secondary"
          handleSecondaryBtn={() => setDetails(false)}
          secondaryBtnvariant="primary"
          secondaryBtnText="Okay"
          hidePrimaryBtn
        />
      }
      open={isDetails}
      setOpen={(Value) => setDetails(Value)}
    >
      <div className="modal-content pb-0 pt-0">
        <div className="request-details flex gap-6">
          <div className="detail-item flex">
            <span className="label">Ward</span>
            <TagComp className="orange">{data?.ward} </TagComp>
          </div>
          <div className="detail-item">
            <span className="label">Requested on</span>
            <span className="value">{data?.submitted_date}</span>
          </div>
          <div className="detail-item">
            <span className="label">Status</span>
            {tabActive === "2" ? (
              <TagComp
                className={
                  data?.map_status_flg === 1 ? "ant-tag-green" : "ant-tag-red"
                }
              >
                {data?.map_status_flg === 1 ? "Approved" : "Rejected"}
              </TagComp>
            ) : (
              <TagComp className="orange">Pending</TagComp>
            )}
          </div>
        </div>

        <div className="new-councillor">
          <h3 className="label">
            {tabActive === "1"
              ? "Nominated Councillor"
              : data?.map_status_flg === 1
              ? "New councillor"
              : "Nominated Councillor"}
          </h3>
          <div className="councillor-info ">
            <div className="flex align-center">
              {data?.councilor_image ? (
                <span className="councilor_image">
                  <AvatarComp
                    shape="square"
                    size={32}
                    blue
                    src={data?.councilor_image}
                  />
                </span>
              ) : (
                <span className="councilor_image">
                  <AvatarComp size={32} shape="square" blue>
                    {data?.first_name?.replace(" ", "")[0]}
                  </AvatarComp>
                </span>
              )}
              <span className="name">
                {data?.first_name + " " + data?.last_name}
              </span>
            </div>
            <div className=" flex justify-center align-center">
              <span className="calender_icon">
                <CalenderTermIcon />
              </span>
              <span className="term">{data?.term}</span>
            </div>
          </div>
        </div>

        {data?.map_status_flg !== 1 && (
          <div className="reason">
            <h4 className="label">Reason</h4>
            <p>{data?.reason}</p>
          </div>
        )}
      </div>
    </ModalComp>
  );
}

export default CouncillorDetails;
